import { ReduceStore } from 'flux/utils';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

const LOCALSTORAGE_KEY = 'currentOrganizationId';

function setOrgId(orgId) {
  localStorage.setItem(LOCALSTORAGE_KEY, orgId);
  return orgId;
}

function clearOrgId() {
  localStorage.removeItem(LOCALSTORAGE_KEY);
  return null;
}

class CurrentOrganizationIdStore extends ReduceStore {
  getInitialState() {
    return +localStorage.getItem(LOCALSTORAGE_KEY) || null;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.Admin.ORGANIZATION_SET:
        return setOrgId(action.organizationId);
      case Constants.Admin.CURRENT_USER_LOADED:
        // Automatically Select an Organization when the current user only has
        // one organization available
        if (action.user.memberships.length === 1) {
          return setOrgId(action.user.memberships[0].organization.id);
        }
        return state;
      case Constants.USER_LOGGED_OUT:
        return clearOrgId();
      default:
        return state;
    }
  }

  getOrganizationId() {
    return this.getState();
  }
}

const instance = new CurrentOrganizationIdStore(AppDispatcher);
export default instance;
